import { render, staticRenderFns } from "./STableTaxComp.vue?vue&type=template&id=adf0a3ac&"
import script from "./STableTaxComp.vue?vue&type=script&lang=js&"
export * from "./STableTaxComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports